import { render } from "./IconBase.vue?vue&type=template&id=41d71c64&scoped=true&ts=true"
import script from "./IconBase.vue?vue&type=script&lang=ts"
export * from "./IconBase.vue?vue&type=script&lang=ts"

import "./IconBase.vue?vue&type=style&index=0&id=41d71c64&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d71c64"]])

export default __exports__